import React from 'react'

import { Helmet } from 'react-helmet'

import './frame-inicio.css'

const FrameInicio = (props) => {
  return (
    <div className="frame-inicio-container1">
      <Helmet>
        <title>exported project</title>
        <meta property="og:title" content="exported project" />
        <link rel="canonical" href="https://editables-2vae8f.teleporthq.app/" />
      </Helmet>
      <div className="frame-inicio-thq-frame-inicio-elm">
        <div className="frame-inicio-thq-group16-elm">
          <img
            src="/image1a11257-4ps-1400w.png"
            alt="IMAGE1A11257"
            className="frame-inicio-thq-image1a1-elm"
          />
          <img
            src="/handsofprayeronaholybibleonwoodtablewith20231127052002-je8r-600h.png"
            alt="handsofprayeronaholybibleonwoodtablewith20231127052002"
            className="frame-inicio-thq-handsofprayeronaholybibleonwoodtablewith2023112705-elm"
          />
        </div>
        <span className="frame-inicio-thq-text-elm10">Lorem Impsun</span>
        <img
          src="/rectangle61260-cunf-200h.png"
          alt="Rectangle61260"
          className="frame-inicio-thq-rectangle6-elm"
        />
        <span className="frame-inicio-thq-text-elm11">CONOCENOS</span>
        <img
          src="/rectangle1041262-rfbc-200h.png"
          alt="Rectangle1041262"
          className="frame-inicio-thq-rectangle104-elm"
        />
        <span className="frame-inicio-thq-text-elm12">Informes</span>
        <div className="frame-inicio-thq-group30-elm">
          <img
            src="/rectangle1251264-435m-200h.png"
            alt="Rectangle1251264"
            className="frame-inicio-thq-rectangle125-elm1"
          />
          <img
            src="/rectangle1461265-mol-200h.png"
            alt="Rectangle1461265"
            className="frame-inicio-thq-rectangle146-elm"
          />
          <div className="frame-inicio-thq-group22-elm">
            <img
              src="/ellipse301291-y1es-200h.png"
              alt="Ellipse301291"
              className="frame-inicio-thq-ellipse30-elm"
            />
            <div className="frame-inicio-thq-wtj7-ns-elm">
              <div className="frame-inicio-thq-group-elm1">
                <img
                  src="/vector1294-5lr6m.svg"
                  alt="Vector1294"
                  className="frame-inicio-thq-vector-elm1"
                />
                <img
                  src="/vector1295-hrt.svg"
                  alt="Vector1295"
                  className="frame-inicio-thq-vector-elm2"
                />
                <img
                  src="/vector1296-mklp.svg"
                  alt="Vector1296"
                  className="frame-inicio-thq-vector-elm3"
                />
              </div>
            </div>
          </div>
          <div className="frame-inicio-thq-group23-elm">
            <img
              src="/ellipse311298-3yij-200h.png"
              alt="Ellipse311298"
              className="frame-inicio-thq-ellipse31-elm"
            />
            <img
              src="/vector1299-k7ae.svg"
              alt="Vector1299"
              className="frame-inicio-thq-vector-elm4"
            />
          </div>
          <span className="frame-inicio-thq-text-elm13">Contáctanos</span>
        </div>
        <img
          src="/rectangle1061301-lam6-300w.png"
          alt="Rectangle1061301"
          className="frame-inicio-thq-rectangle106-elm"
        />
        <img
          src="/rectangle1071302-fsq2-300w.png"
          alt="Rectangle1071302"
          className="frame-inicio-thq-rectangle107-elm"
        />
        <img
          src="/schoolkidsgivingthumbsup20231127051237utcmin11303-8ab-300w.png"
          alt="schoolkidsgivingthumbsup20231127051237utcmin11303"
          className="frame-inicio-thq-schoolkidsgivingthumbsup20231127051237utcmin1-elm"
        />
        <img
          src="/rectangle1081304-2jj-300w.png"
          alt="Rectangle1081304"
          className="frame-inicio-thq-rectangle108-elm"
        />
        <img
          src="/rectangle1091305-657m-300w.png"
          alt="Rectangle1091305"
          className="frame-inicio-thq-rectangle109-elm"
        />
        <span className="frame-inicio-thq-text-elm14">Enfoque Ministerial</span>
        <span className="frame-inicio-thq-text-elm15">
          <span className="frame-inicio-thq-text-elm16">
            Conoce porque este Instituto
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span>es para ti</span>
        </span>
        <span className="frame-inicio-thq-text-elm18">Formación Integral</span>
        <span className="frame-inicio-thq-text-elm19">Formación Bíblica</span>
        <span className="frame-inicio-thq-text-elm20">Accesible y Actual</span>
        <img
          src="/studentonlinecutegirlinglassesandsweaterst202311271313-bb4q-300w.png"
          alt="studentonlinecutegirlinglassesandsweaterst202311271313"
          className="frame-inicio-thq-studentonlinecutegirlinglassesandsweaterst20231127-elm1"
        />
        <span className="frame-inicio-thq-text-elm21">
          Programas accesibles que permiten estudiar sin descuidar la vida
          familiar, laboral y ministerial.
        </span>
        <span className="frame-inicio-thq-text-elm22">
          Desarrollo espiritual, teológico y humano, formando ministros con
          carácter, ética y responsabilidad.
        </span>
        <span className="frame-inicio-thq-text-elm23">
          Preparación práctica para el servicio cristiano, liderazgo
          eclesiástico y el discipulado.
        </span>
        <span className="frame-inicio-thq-text-elm24">
          Estudio profundo de las Escrituras con fundamentos sólidos en la
          Palabra de Dios.
        </span>
        <img
          src="/studentonlinecutegirlinglassesandsweaterst202311271316-dbq-300w.png"
          alt="studentonlinecutegirlinglassesandsweaterst202311271316"
          className="frame-inicio-thq-studentonlinecutegirlinglassesandsweaterst20231127-elm2"
        />
        <img
          src="/image1c11317-fh6-300w.png"
          alt="IMAGE1C11317"
          className="frame-inicio-thq-image1c1-elm"
        />
        <img
          src="/image1b11318-iogi-300w.png"
          alt="IMAGE1B11318"
          className="frame-inicio-thq-image1b1-elm"
        />
        <img
          src="/rectangle1611319-f1zg-200w.png"
          alt="Rectangle1611319"
          className="frame-inicio-thq-rectangle161-elm"
        />
        <img
          src="/ellipse11320-qmw-200h.png"
          alt="Ellipse11320"
          className="frame-inicio-thq-ellipse1-elm"
        />
        <img
          src="/ellipse408156-684s-200h.png"
          alt="Ellipse408156"
          className="frame-inicio-thq-ellipse40-elm"
        />
        <img
          src="/ellipse418156-27k-200h.png"
          alt="Ellipse418156"
          className="frame-inicio-thq-ellipse41-elm"
        />
        <span className="frame-inicio-thq-text-elm25">
          Estudiar en este Instituto fortaleció mi llamado y me dio claridad
          doctrinal para servir mejor a la iglesia.
        </span>
        <span className="frame-inicio-thq-text-elm26">Ps....... - XX años</span>
        <span className="frame-inicio-thq-text-elm27">
          No solo aprendí teología, crecí espiritualmente y confirmé mi vocación
        </span>
        <img
          src="/rectangle1101326-lrph-400w.png"
          alt="Rectangle1101326"
          className="frame-inicio-thq-rectangle110-elm"
        />
        <img
          src="/svg1327-vtd.svg"
          alt="SVG1327"
          className="frame-inicio-thq-svg-elm1"
        />
        <span className="frame-inicio-thq-text-elm28">
          Diana Luna, egresada
        </span>
        <span className="frame-inicio-thq-text-elm29">
          La enseñanza bíblica profunda me ayudó a predicar con mayor
          responsabilidad y fidelidad a la Palabra.
        </span>
        <span className="frame-inicio-thq-text-elm30">
          Luis Flores, estudiante de Teología
        </span>
        <img
          src="/rectangle174715-zv6-400w.png"
          alt="Rectangle174715"
          className="frame-inicio-thq-rectangle174-elm"
        />
        <img
          src="/svg716-9obe.svg"
          alt="SVG716"
          className="frame-inicio-thq-svg-elm2"
        />
        <span className="frame-inicio-thq-text-elm31">Experiencias</span>
        <img
          src="/rectangle1131331-twc8-400w.png"
          alt="Rectangle1131331"
          className="frame-inicio-thq-rectangle113-elm"
        />
        <img
          src="/svg1332-y0xg.svg"
          alt="SVG1332"
          className="frame-inicio-thq-svg-elm3"
        />
        <div className="frame-inicio-thq-group13-elm">
          <img
            src="/onlineeducation20231127052318utcmin11370-a84h-600w.png"
            alt="onlineeducation20231127052318utcmin11370"
            className="frame-inicio-thq-onlineeducation20231127052318utcmin1-elm"
          />
          <img
            src="/rectangle1251371-fb2x-400w.png"
            alt="Rectangle1251371"
            className="frame-inicio-thq-rectangle125-elm2"
          />
          <span className="frame-inicio-thq-text-elm32">
            <span>Preparación para el servicio cristiano</span>
            <br></br>
          </span>
        </div>
        <div className="frame-inicio-thq-group25-elm">
          <img
            src="/ayoungwomanstandingandprayingonthebiblec20231127051374-htt-600w.png"
            alt="ayoungwomanstandingandprayingonthebiblec20231127051374"
            className="frame-inicio-thq-ayoungwomanstandingandprayingonthebiblec2023112705-elm"
          />
          <img
            src="/rectangle1264001-3gpg-400w.png"
            alt="Rectangle1264001"
            className="frame-inicio-thq-rectangle126-elm"
          />
          <span className="frame-inicio-thq-text-elm34">
            <span>Ventajas de estudiar Teología</span>
            <br></br>
          </span>
        </div>
        <div className="frame-inicio-thq-group15-elm">
          <img
            src="/ellipse261378-2mj-200h.png"
            alt="Ellipse261378"
            className="frame-inicio-thq-ellipse26-elm1"
          />
          <div className="frame-inicio-thq-group-elm2">
            <div className="frame-inicio-thq-capa1-elm1">
              <div className="frame-inicio-thq-group-elm3">
                <img
                  src="/vector1382-6eo.svg"
                  alt="Vector1382"
                  className="frame-inicio-thq-vector-elm5"
                />
                <img
                  src="/vector1383-o63q.svg"
                  alt="Vector1383"
                  className="frame-inicio-thq-vector-elm6"
                />
              </div>
            </div>
          </div>
        </div>
        <img
          src="/rectangle173710-ob2w-200h.png"
          alt="Rectangle173710"
          className="frame-inicio-thq-rectangle173-elm"
        />
        <div className="frame-inicio-thq-group26-elm">
          <img
            src="/ellipse2673-nvtn-200h.png"
            alt="Ellipse2673"
            className="frame-inicio-thq-ellipse26-elm2"
          />
          <div className="frame-inicio-thq-group-elm4">
            <div className="frame-inicio-thq-capa1-elm2">
              <div className="frame-inicio-thq-group-elm5">
                <img
                  src="/vector77-yru.svg"
                  alt="Vector77"
                  className="frame-inicio-thq-vector-elm7"
                />
                <img
                  src="/vector78-qx7f.svg"
                  alt="Vector78"
                  className="frame-inicio-thq-vector-elm8"
                />
              </div>
            </div>
          </div>
        </div>
        <span className="frame-inicio-thq-text-elm36">777-000-0000</span>
        <div className="frame-inicio-thq-group31-elm">
          <span className="frame-inicio-thq-text-elm37">
            <span>777-111-0000</span>
            <br></br>
            <span>
              Calle Felipe Angeles SN Col Lomas de la Selva, 62000 Cuernavaca,
              Mor. 
            </span>
          </span>
        </div>
        <div className="frame-inicio-thq-group37-elm">
          <div className="frame-inicio-thq-group34-elm">
            <span className="frame-inicio-thq-text-elm40">Inicio</span>
            <span className="frame-inicio-thq-text-elm41">Nosotros</span>
            <span className="frame-inicio-thq-text-elm42">
              Oferta Educativa
            </span>
            <span className="frame-inicio-thq-text-elm43">Admisiones</span>
            <span className="frame-inicio-thq-text-elm44">
              Preguntas frecuentes
            </span>
            <span className="frame-inicio-thq-text-elm45">Ingresa</span>
          </div>
          <img
            src="/image22002-ypjn-200h.png"
            alt="image22002"
            className="frame-inicio-thq-image2-elm"
          />
        </div>
        <div className="frame-inicio-thq-group38-elm">
          <span className="frame-inicio-thq-text-elm46">
            <span className="frame-inicio-thq-text-elm47">Conoce</span>
            <span> el plan de estudios</span>
          </span>
          <span className="frame-inicio-thq-text-elm49">
            <span className="frame-inicio-thq-text-elm50">Semestre I</span>
            <br></br>
            <span className="frame-inicio-thq-text-elm51"></span>
            <br></br>
            <span>Introducción a la Teología</span>
            <br></br>
            <span>Bibliología</span>
            <br></br>
            <span>Hermenéutica Bíblica</span>
            <br></br>
            <span>Panorama del Antiguo Testamento</span>
            <br></br>
            <span>Vida Devocional</span>
          </span>
          <span className="frame-inicio-thq-text-elm57">
            <span className="frame-inicio-thq-text-elm58">Semestre</span>
            <span className="frame-inicio-thq-text-elm59">
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
            <span className="frame-inicio-thq-text-elm60"> II</span>
            <br></br>
            <span className="frame-inicio-thq-text-elm61"> </span>
            <br></br>
            <span>Panorama del Nuevo Testamento</span>
            <br></br>
            <span>Cristología</span>
            <br></br>
            <span>Neumatología</span>
            <br></br>
            <span>Homilética I</span>
            <br></br>
            <span>Ética Cristiana</span>
          </span>
          <span className="frame-inicio-thq-text-elm67">
            <span className="frame-inicio-thq-text-elm68">Semestre III</span>
            <br></br>
            <span className="frame-inicio-thq-text-elm69"> </span>
            <br></br>
            <span>Historia de la Iglesia</span>
            <br></br>
            <span>Soteriología</span>
            <br></br>
            <span>Eclesiología</span>
            <br></br>
            <span>Homilética II</span>
            <br></br>
            <span>Liderazgo Cristiano</span>
          </span>
          <span className="frame-inicio-thq-text-elm75">
            <span className="frame-inicio-thq-text-elm76">Semestre IV</span>
            <br></br>
            <span className="frame-inicio-thq-text-elm77"> </span>
            <br></br>
            <span>Escatología</span>
            <br></br>
            <span>Consejería Pastoral</span>
            <br></br>
            <span>Misiones</span>
            <br></br>
            <span>Apologética</span>
            <br></br>
            <span>Proyecto Ministerial Final</span>
          </span>
        </div>
      </div>
      <a href="https://play.teleporthq.io/signup" className="frame-inicio-link">
        <div
          aria-label="Sign up to TeleportHQ"
          className="frame-inicio-container2"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 19 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="frame-inicio-icon1"
          >
            <path
              d="M9.1017 4.64355H2.17867C0.711684 4.64355 -0.477539 5.79975 -0.477539 7.22599V13.9567C-0.477539 15.3829 0.711684 16.5391 2.17867 16.5391H9.1017C10.5687 16.5391 11.7579 15.3829 11.7579 13.9567V7.22599C11.7579 5.79975 10.5687 4.64355 9.1017 4.64355Z"
              fill="#B23ADE"
            ></path>
            <path
              d="M10.9733 12.7878C14.4208 12.7878 17.2156 10.0706 17.2156 6.71886C17.2156 3.3671 14.4208 0.649963 10.9733 0.649963C7.52573 0.649963 4.73096 3.3671 4.73096 6.71886C4.73096 10.0706 7.52573 12.7878 10.9733 12.7878Z"
              fill="#FF5C5C"
            ></path>
            <path
              d="M17.7373 13.3654C19.1497 14.1588 19.1497 15.4634 17.7373 16.2493L10.0865 20.5387C8.67402 21.332 7.51855 20.6836 7.51855 19.0968V10.5141C7.51855 8.92916 8.67402 8.2807 10.0865 9.07221L17.7373 13.3654Z"
              fill="#2874DE"
            ></path>
          </svg>
          <span className="frame-inicio-text37">Built in TeleportHQ</span>
        </div>
      </a>
    </div>
  )
}

export default FrameInicio
